import {useContext} from 'react';
import {Alert, Badge, Button, Card, Divider, Modal, Table} from 'antd';
import {Context} from '../../App';
import {CheckOutlined, CloseOutlined} from '@ant-design/icons';

type Props = {
    open: boolean;
    onCancel: () => void;
    message?: string;
};

export default function PayForUser({open, onCancel, message}: Props) {
    const {user} = useContext(Context);

    return (
        <Modal
            open={open}
            onCancel={() => {
                onCancel();
            }}
            footer={false}
            title='Hvað er innifalið í áskrift?'
        >
            {message && <Alert message={message} type='error'></Alert>}

            <div>
                <div>
                    <div style={{display: 'flex', flexDirection: 'row', gap: 10}}>
                        <div>
                            <Table
                                style={{
                                    marginBottom: 20,
                                }}
                                size='small'
                                pagination={false}
                                dataSource={[
                                    {
                                        title: 'SMS og Messenger tilkynningar',
                                        premium: true,
                                        basic: false,
                                    },
                                    {
                                        title: 'Hægt að skipta í lið',
                                        premium: true,
                                        basic: false,
                                    },
                                    {
                                        title: 'Hægt að fela liðið fyrir almenningi',
                                        premium: true,
                                        basic: false,
                                    },
                                ]}
                                columns={[
                                    {
                                        title: '',
                                        dataIndex: 'title',
                                        key: 'title',
                                    },
                                    {
                                        title: (
                                            <>
                                                <img
                                                    style={{
                                                        width: 100,
                                                    }}
                                                    src='/static/images/logo/premium.png'
                                                    alt='Áskrift'
                                                />
                                                <small>Áskrift</small>
                                            </>
                                        ),
                                        key: 'premium',
                                        render: (text, record) => {
                                            return (
                                                <>
                                                    <CheckOutlined style={{color: '#00e800'}} />
                                                </>
                                            );
                                        },
                                        align: 'center',
                                    },
                                    {
                                        title: (
                                            <>
                                                <img
                                                    style={{
                                                        width: 100,
                                                    }}
                                                    src='/static/images/logo/new.png'
                                                    alt='Áskrift'
                                                />
                                                Frítt
                                            </>
                                        ),
                                        key: 'basic',
                                        render: (text, record) => {
                                            return (
                                                <>
                                                    <CloseOutlined style={{color: '#e80000'}} />
                                                </>
                                            );
                                        },
                                        align: 'center',
                                    },
                                ]}
                            ></Table>
                        </div>
                    </div>

                    <Divider style={{margin: '20px 0'}}>Greiðsluleiðir</Divider>

                    <div style={{display: 'flex', flexDirection: 'row', gap: 20}}>
                        <Card
                            style={{flex: 1, backgroundColor: '#f0f0f0'}}
                            extra='1 mán / fresti'
                            styles={{
                                body: {
                                    paddingTop: 0,
                                },
                            }}
                        >
                            <div style={{fontSize: 20, fontWeight: 'bold', textAlign: 'center'}}>
                                <p>690 kr á mánuði</p>
                                <p style={{fontSize: 12, fontWeight: 'normal'}}>&nbsp;</p>
                            </div>

                            <Button
                                href={
                                    'https://repeat.is/repeat_checkout/da79b628-ff2b-4c6d-b078-dbe1066d132f/?products.0.uuid=3c68fdcd-9323-4a7e-a825-b19a105ab936&products.0.quantity=1&currency=ISK&language=is&interval_type=YEAR&interval_count=1&name=&email=&external_ref=' +
                                    user?.uuid
                                }
                                type='primary'
                                block
                                size='large'
                            >
                                Kaupa áskrift
                            </Button>
                        </Card>

                        <Card
                            style={{flex: 1, backgroundColor: '#f0f0f0'}}
                            extra='12 mán / fresti'
                            styles={{
                                body: {
                                    paddingTop: 0,
                                },
                            }}
                        >
                            <div style={{fontSize: 20, fontWeight: 'bold', textAlign: 'center'}}>
                                <p>499 kr / mán</p>
                                <p style={{fontSize: 12, fontWeight: 'normal'}}>
                                    <small>5.990 kr. Greitt árlega</small>
                                </p>
                            </div>
                            <Button
                                href={
                                    'https://repeat.is/repeat_checkout/da79b628-ff2b-4c6d-b078-dbe1066d132f/?products.0.uuid=3c68fdcd-9323-4a7e-a825-b19a105ab936&products.0.quantity=1&currency=ISK&language=is&interval_type=YEAR&interval_count=1&name=&email=&external_ref=' +
                                    user?.uuid
                                }
                                type='primary'
                                block
                                size='large'
                            >
                                Kaupa áskrift
                            </Button>
                        </Card>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
